module.exports = __webpack_public_path__ + "img/chicken.8c167ec5.svg";